import _ from 'lodash';

export default class PagesModel {
    /**
     */
    constructor(parent, { pages }) {
        const pagesWithHref = pages.map(page => (
            { ...page,
                icon: parent.getIcon(page.icon),
                domId: `${_.kebabCase(page.id)}`,
                pages: page.pages && page.pages.map(subPage => (
                    { ...subPage,
                        domId: `${_.kebabCase(subPage.id)}`,
                        icon: parent.getIcon(subPage.icon),
                    }))
            }));
        this.pages = Object.freeze(pagesWithHref);
        this.currentPage = this.pages[0];
    }

    isSelected(page) {
        return page === this.currentPage;
    }

    hasSelected(page) {
        if (!this.currentPage) {
            return false;
        }
        return this.isSelected(page) || _.find(page.pages, this.currentPage);
    }

    setCurrentPageById(id) {
        let found = _.find(this.pages, { id });
        if (found) {
            this.currentPage = found;
            return found;
        }
        const subPages = _(this.pages).map('pages').flatten().value();
        found = _.find(subPages, { id });
        if (found) {
            this.currentPage = found;
        }
        return found;
    }

    setCurrentPageByDomId(domId) {
        return this.setCurrentPageById(_.camelCase(domId));
    }
}
